import { render, staticRenderFns } from "./FormFirm.vue?vue&type=template&id=3b19037f&scoped=true&"
import script from "./FormFirm.vue?vue&type=script&lang=js&"
export * from "./FormFirm.vue?vue&type=script&lang=js&"
import style0 from "./FormFirm.vue?vue&type=style&index=0&id=3b19037f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b19037f",
  null
  
)

export default component.exports